import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Rental } from './rental'
import { RentalSerializer } from './rental.serializer'

@Injectable()
export class RentalService extends ResourceService<Rental> {
  constructor(public http: HttpClient, rentalSerializer: RentalSerializer) {
    super(http, `${environment.backendApiUrl}/rentals`, rentalSerializer)
  }
}
